import { FormControlLabel, Switch, TextFieldProps } from "@mui/material";
import { Control, Controller } from "react-hook-form";

type Props = {
  name: string;
  label?: TextFieldProps["label"];
  control: Control<any>;
  disabled?: boolean;
  onChange?: (e: any, field?: any) => void;
};

const ControlledSwitch = ({
  name,
  control,
  label,
  disabled,
  onChange,
}: Props) => {
  return (
    <Controller
      key={`${name}-switch`}
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Switch
              {...field}
              onChange={
                onChange ? (e: any) => onChange(e, field) : field.onChange
              }
              checked={Boolean(field.value)}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          disabled={disabled}
          label={label}
        />
      )}
    />
  );
};

export default ControlledSwitch;
